<template>
  <v-data-table :headers="headers" :items="data" hide-actions :loading="loading" :custom-sort="sortByNum"
    :pagination.sync="localPagination" must-sort class="primary home-table">
    <template v-slot:items="props">
      <v-tooltip top class="expire-tooltip-wrapper"
        :content-class="(isNearingRenew(props.item.plant_id) || isRenewExceeded(props.item.plant_id)) ? 'custom-tooltip expire-tooltip' : 'custom-tooltip'"
        :disabled="isPlantExpired(props.item.plant_id) || (!isNearingRenew(props.item.plant_id) && !isRenewExceeded(props.item.plant_id))">
        <template v-slot:activator="{ on }">
          <tr v-on="on" :class="highlight(props.item.plant_id)"
            @click="!resizeState.wasResizing && $emit('row-clicked', props.item)" class="primaryText--text">
            <td v-for="header in headers" :key="header.value"
              :class="[header.value === 'alert' ? '' : 'overflowtext', (header.value === 'generation' && props.item.generation === 'No data') || (header.value === 'power' && props.item.power === 'No data') || (['acyield', 'cuf', 'ratio'].includes(header.value) && !props.item[header.value]) ? 'error--text' : '', (header.value === 'generation' && props.item.generation !== 'No data') || (header.value === 'power' && props.item.power !== 'No data') || (['acyield', 'cuf', 'ratio'].includes(header.value) && props.item[header.value]) || header.value === 'ac_capacity' ? 'number--text' : '']"
              :id="header.value">
              <template v-if="header.value === 'plant_name'">
                <v-tooltip top content-class="custom-tooltip">
                  <template v-slot:activator="{ on }">
                    <span v-on="on">{{ props.item.plant_name }}</span>
                  </template>
                  <span>{{ props.item.plant_name }}</span>
                </v-tooltip>
              </template>


              <template v-else-if="header.value === 'location'">
                <v-tooltip top content-class="custom-tooltip">
                  <template v-slot:activator="{ on }">
                    <span v-on="on">{{ props.item.location }}</span>
                  </template>
                  <span>{{ props.item.location }}</span>
                </v-tooltip>
              </template>

              <template v-else-if="header.value === 'generation'">
                <span v-if="!isPlantExpired(props.item.plant_id)">
                  <span v-show="props.item.generation !== 'No data'">
                    {{ props.item.generation | numberWithCommas }}
                  </span>
                  <span v-show="props.item.generation == 'No data'">
                    {{ $t('No data') }}
                  </span>
                </span>
              </template>

              <template v-else-if="header.value === 'power'">
                <span v-if="!isPlantExpired(props.item.plant_id)">
                  <span>{{ props.item.power !== 'No data' ? props.item.power : $t('No data') }}</span>
                </span>
              </template>

              <template v-else-if="header.value === 'acyield'">
                <span v-if="!isPlantExpired(props.item.plant_id)">
                  <span v-if="props.item.acyield == null">{{ $t('No data') }}</span>
                  <span v-else>{{ props.item.acyield | round }}</span>
                </span>
              </template>

              <template v-else-if="header.value === 'cuf'">
                <span v-if="!isPlantExpired(props.item.plant_id)">
                  <span v-if="props.item.cuf == null">{{ $t('No data') }}</span>
                  <span v-else>{{ props.item.cuf | round }}</span>
                </span>
              </template>

              <template v-else-if="header.value === 'ratio'">
                <span v-if="!isPlantExpired(props.item.plant_id)">
                  <span v-if="props.item.ratio == null">{{ $t('No data') }}</span>
                  <span v-else-if="props.item.ratio > 100">---</span>
                  <span v-else>{{ props.item.ratio | round }}</span>
                </span>
              </template>

              <template v-else-if="header.value === 'ac_capacity'">
                <span>{{ props.item.ac_capacity }}</span>
              </template>

              <template v-else-if="header.value === 'alert'">
                <span v-if="!isPlantExpired(props.item.plant_id)">
                  <span v-for="(value, key) in props.item.alert" v-bind:key="key">
                    <AlertIndicator :alertTag="alertShorthand(key)" :tip="key.toUpperCase()" :alert="value === 'alert'"
                      @click="
                        $emit('alert-action', {
                          plantId: props.item.plant_id,
                          alert: key,
                        })
                        "></AlertIndicator>
                  </span>
                </span>
              </template>

              <div class="col-resizer" :data-header-value="header.value"></div>
            </td>
          </tr>
        </template>
        <div class="text-center pa-1">
          <p class="font-weight-bold mb-2">{{ props.item.plant_name }}</p>
          <p v-if="getExpiryDateCount(props.item.plant_id) && getExpiryDateCount(props.item.plant_id) > 0"
            class="renew-msg mb-1">
            {{ getExpiryDateCount(props.item.plant_id) }} days to Expire
          </p>
          <p v-if="getRenewDate(props.item.plant_id)" class="renew-msg mb-0">
            Renew till : {{ getRenewDate(props.item.plant_id) }}
          </p>
        </div>
      </v-tooltip>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters } from "vuex";
import { mixin } from "@/util/mixin/index";

import AlertIndicator from "@/components/home/DataTable/AlertIndicator";

export default {
  props: {
    headers: {
      type: Array,
      default: function () {
        return [];
      },
    },
    data: {
      type: Array,
      default: function () {
        return [];
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
    pagination: {
      type: Object,
      default: () => ({}),
    },
  },
  mixins: [mixin],
  components: {
    AlertIndicator,
  },
  data() {
    return {
      localPagination: this.pagination,
      resizeState: {
        active: false,
        wasResizing: false,
        header: null,
        startX: 0,
        startWidth: 0,
        colElement: null,
        newWidth: null,
        activeResizers: []
      }
    };
  },
  computed: {
    ...mapGetters([
      "isNearingRenew",
      "isRenewExceeded",
      "isPlantExpired",
      "getExpiryDateCount",
      "getRenewDate",
    ]),
  },
  mounted() {
    this.$el.addEventListener('mousedown', this.handleMouseDown);
    this.$el.addEventListener('mouseover', this.handleMouseOver);
    this.$el.addEventListener('mouseout', this.handleMouseOut);
    this.$nextTick(() => {
      this.injectColGroup();
    });
  },
  beforeDestroy() {
    this.$el.removeEventListener('mousedown', this.handleMouseDown);
    this.$el.removeEventListener('mouseover', this.handleMouseOver);
    this.$el.removeEventListener('mouseout', this.handleMouseOut);
  },
  methods: {
    handleMouseOver(event) {
      if (this.resizeState.active) return;
      const resizer = event.target.closest('.col-resizer');
      if (!resizer) return;
      const headerValue = resizer.getAttribute('data-header-value');
      if (!headerValue) return;
      const allResizers = this.$el.querySelectorAll(`.col-resizer[data-header-value="${headerValue}"]`);
      allResizers.forEach(r => r.classList.add('resizer-hovered'));
    },
    handleMouseOut(event) {
      if (this.resizeState.active) return;
      const resizer = event.target.closest('.col-resizer');

      if (!resizer) return;
      const headerValue = resizer.getAttribute('data-header-value');

      if (!headerValue) return;
      const allResizers = this.$el.querySelectorAll(`.col-resizer[data-header-value="${headerValue}"]`);
      allResizers.forEach(r => r.classList.remove('resizer-hovered'));
    },
    handleMouseDown(event) {
      const resizer = event.target.closest('.col-resizer');

      if (!resizer) return;
      event.preventDefault();
      event.stopPropagation();

      const headerValue = resizer.getAttribute('data-header-value');
      const header = this.headers.find(h => h.value === headerValue);

      if (header) {
        this.startResize(header, event);
      }
    },
    injectColGroup() {
      const table = this.$el.querySelector('table');

      if (!table) return;
      const existing = table.querySelector('colgroup.resize-colgroup');

      if (existing) existing.remove();
      const colgroup = document.createElement('colgroup');
      colgroup.className = 'resize-colgroup';

      this.headers.forEach(header => {
        const col = document.createElement('col');
        col.dataset.colValue = header.value;

        if (header.width) {
          const w = parseInt(header.width);
          col.style.width = w + 'px';
          col.style.minWidth = w + 'px';
        }

        colgroup.appendChild(col);
      });

      table.insertBefore(colgroup, table.firstChild);
      const ths = table.querySelectorAll('thead th');

      ths.forEach((th, idx) => {
        const header = this.headers[idx];
        if (!header) return;

        if (getComputedStyle(th).position === 'static') {
          th.style.position = 'relative';
        }

        let resizer = th.querySelector('.col-resizer');

        if (!resizer) {
          resizer = document.createElement('div');
          resizer.className = 'col-resizer';
          resizer.setAttribute('data-header-value', header.value);
          th.appendChild(resizer);
        } else {
          resizer.setAttribute('data-header-value', header.value);
        }
      });
    },
    startResize(header, event) {
      const colgroup = this.$el.querySelector('colgroup.resize-colgroup');

      if (!colgroup) return;
      const col = colgroup.querySelector(`col[data-col-value="${header.value}"]`);

      if (!col) return;
      const idx = this.headers.findIndex(h => h.value === header.value);
      const ths = this.$el.querySelectorAll('thead th');
      const th = ths[idx];
      const currentWidth = th ? th.offsetWidth : (parseInt(col.style.width) || 100);

      this.resizeState.colElement = col;
      this.resizeState.startWidth = currentWidth;
      this.resizeState.header = header;
      this.resizeState.startX = event.clientX;
      this.resizeState.active = true;
      this.resizeState.newWidth = null;

      const activeResizers = this.$el.querySelectorAll(`.col-resizer[data-header-value="${header.value}"]`);
      activeResizers.forEach(r => r.classList.add('resizer-active'));
      this.resizeState.activeResizers = activeResizers;

      document.addEventListener('mousemove', this.onMouseMove);
      document.addEventListener('mouseup', this.onMouseUp);
    },
    onMouseMove(event) {
      if (!this.resizeState.active) return;

      const diff = event.clientX - this.resizeState.startX;
      let newWidth = this.resizeState.startWidth + diff;
      newWidth = Math.max(newWidth, 60);
      this.resizeState.newWidth = newWidth;

      if (this.resizeState.colElement) {
        this.resizeState.colElement.style.width = newWidth + 'px';
        this.resizeState.colElement.style.minWidth = newWidth + 'px';
      }
    },
    onMouseUp() {
      if (!this.resizeState.active) return;

      this.resizeState.activeResizers.forEach(r => {
        r.classList.remove('resizer-active');
        r.classList.remove('resizer-hovered');
      });

      this.resizeState.activeResizers = [];
      this.resizeState.active = false;
      this.resizeState.wasResizing = true;

      setTimeout(() => {
        this.resizeState.wasResizing = false;
      }, 0);

      document.removeEventListener('mousemove', this.onMouseMove);
      document.removeEventListener('mouseup', this.onMouseUp);

      if (this.resizeState.newWidth && this.resizeState.header) {
        this.$emit('update-col-width', { value: this.resizeState.header.value, width: this.resizeState.newWidth });
      }
    },
    alertShorthand(device) {
      return device.charAt(0).toUpperCase();
    },
    sortByNum(item, index, isDesc) {
      function numericCompare(a, b) {
        if (isDesc === true) {
          if (
            parseFloat(a[index].toString().replace(/,/gi, "")) <
            parseFloat(b[index].toString().replace(/,/gi, ""))
          ) {
            return -1;
          }
          if (
            parseFloat(a[index].toString().replace(/,/gi, "")) >
            parseFloat(b[index].toString().replace(/,/gi, ""))
          ) {
            return 1;
          }
        } else if (isDesc === false) {
          if (
            parseFloat(a[index].toString().replace(/,/gi, "")) >
            parseFloat(b[index].toString().replace(/,/gi, ""))
          ) {
            return -1;
          }
          if (
            parseFloat(a[index].toString().replace(/,/gi, "")) <
            parseFloat(b[index].toString().replace(/,/gi, ""))
          ) {
            return 1;
          }
        }
        return 0;
      }

      function stringCompare(a, b) {
        if (isDesc === true) {
          if (a[index] < b[index]) {
            return -1;
          }
          if (a[index] > b[index]) {
            return 1;
          }
        } else if (isDesc === false) {
          if (a[index] > b[index]) {
            return -1;
          }
          if (a[index] < b[index]) {
            return 1;
          }
        }
        return 0;
      }

      function prSort(a, b) {
        if (isDesc === true) {
          if (typeof a[index] === typeof b[index]) {
            return a[index] < b[index] ? -1 : 1;
          }
          return typeof a[index] > typeof b[index] ? -1 : 1;
        } else if (isDesc === false) {
          if (typeof a[index] === typeof b[index]) {
            return a[index] > b[index] ? -1 : 1;
          }
          return typeof a[index] < typeof b[index] ? -1 : 1;
        }
        return 0;
      }
      if (index === "generation") {
        return item.sort(numericCompare);
      } else if (index === "plant_name") {
        return item.sort(stringCompare);
      } else if (index === "location") {
        return item.sort(stringCompare);
      } else if (index === "ratio") {
        return item.sort(prSort);
      } else if (index === "ac_capacity") {
        return item.sort(numericCompare);
      } else if (index === "power") {
        return item.sort(numericCompare);
      } else {
        return item;
      }
    },
    countExpiryDate(plantId) {
      // Logic removed since tooltip now uses direct getters
    },
    highlight(plantId) {
      const renew = this.isNearingRenew(plantId);
      const exceededRenew = this.isRenewExceeded(plantId);
      const expired = this.isPlantExpired(plantId);
      const className = renew || exceededRenew || expired ? "con-tooltip" : "";
      return `${className} top`;
    },
    toolTip(plantId) {
      return this.isNearingRenew(plantId) || this.isRenewExceeded(plantId) || this.isPlantExpired(plantId);
    },
  },
  watch: {
    pagination: {
      handler(val) {
        this.localPagination = val;
      },
      deep: true,
    },
    localPagination: {
      handler(val) {
        this.$emit("update:pagination", val);
      },
      deep: true,
    },
    headers: {
      handler() {
        this.$nextTick(() => {
          this.injectColGroup();
        });
      },
      deep: true
    }
  }
};
</script>

<style>
.home-table {
  padding: 0 15px;
  height: calc(100vh - 34vh);
  display: flex;
}

.home-table .v-table tbody td {
  height: 42px;
}

.custom-tooltip {
  background-color: var(--v-primary-base) !important;
  color: var(--v-extraGrey-base);
  border-radius: 4px;
  border: 1px solid rgba(83, 122, 228, 0.418);
  z-index: 10 !important;
}

.expire-tooltip {
  background-color: rgba(204, 83, 86, 0.95) !important;
  color: white !important;
  border-color: rgba(204, 83, 86, 0.95) !important;
}

.con-tooltip {
  background: #cc535673;
  cursor: pointer;
}

.renew-msg {
  margin-bottom: 6px;
  margin-top: 6px;
}

.home-table th {
  position: sticky;
  z-index: 2;
  top: 0;
  color: var(--v-extraGrey-base);
  font-weight: 500 !important;
}

.col-resizer {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 5px;
  cursor: col-resize;
  z-index: 10;
}

.col-resizer:hover,
.col-resizer.resizer-hovered,
.col-resizer.resizer-active {
  border-right: 2px solid #4a7fd4;
}

.home-table .v-table__overflow {
  overflow: auto;
}

.home-table table {
  table-layout: fixed !important;
  border-collapse: collapse;
  border: 1px solid #38405C;
}

.home-table .v-table thead th {
  border-right: 1px solid #38405C !important;
  background: var(--v-primary-base);
  border-top: 1px solid #38405C;
  border-bottom: 2px solid #38405C !important;
}

.home-table th,
.home-table td {
  border-right: 1px solid #38405C !important;
  border-bottom: 1px solid #38405C !important;
  padding: 0 15px !important;
}

.home-table td {
  position: relative;
}

.home-table th:last-child,
.home-table td:last-child {
  padding-right: 0 !important;
}

.overflowtext {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (max-width: 1200px) and (min-width: 550px) {
  .home-table {
    height: calc(100vh - 350px);
  }
}

@media (max-width: 1240px) {
  .home-table td:last-child {
    width: 600px;
  }
}
</style>
